<div
	id="stickyHeader"
	(mouseover)="toggleHeader(true)"
	(mouseleave)="toggleHeader(false)"
	#stickyHeader
	[@toggle]="scroll$ | async"
	[class]="scroll$ | async"
	[class.sticky-top]="true"
>
	<nstar-content-outlet outletName="header">
		<header class="bg-primary">
			<div class="container-lg pb-2">
				<nav class="navbar navbar-expand-lg navbar-dark">
					<a class="navbar-brand" href="#">
						<img
							style="max-width: 200px; max-height: 40px"
							[src]="config.assets.mainLogo"
							alt="NorthstarMLS"
						/>
					</a>
				</nav>
			</div>
		</header>
	</nstar-content-outlet>
	<nstar-content-outlet outletName="progressbar"
		><app-loading-progress-bar></app-loading-progress-bar
	></nstar-content-outlet>
	<nstar-content-outlet outletName="navigation"></nstar-content-outlet>
	<nstar-content-outlet outletName="toolbar"></nstar-content-outlet>
</div>
<router-outlet
	#routerOutlet="outlet"
	[class.flex-grow-1]="!routerOutlet?.isActivated"
	(activate)="handleRouteActivation($event)"
></router-outlet>
<div class="container-lg" *ngIf="!routerOutlet.isActivated">
	<div class="row">
		<div class="col-12 text-center">Loading...</div>
	</div>
</div>
<nstar-alerts aria-live="polite" aria-atomic="true"></nstar-alerts>
<nstar-content-outlet outletName="footer"
	><app-standard-footer></app-standard-footer
></nstar-content-outlet>
